"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";

import {
  ErrorMarkFilledIcon,
  QuoteFilledIcon,
  WarningMarkFilledIcon,
} from "../icons";
import { CheckCircleFilledIcon } from "../icons/check-icon";
import { SpinnerIcon } from "../icons/spinner-icon";

const Toaster = (props: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      richColors
      toastOptions={{
        classNames: {
          title: "!text-body-medium-medium",
          toast:
            "!rounded-lg !border-0 !shadow-lg !p-2 !w-fit !max-w-[min(90vw,480px)] !left-1/2 !-translate-x-1/2 !whitespace-normal !break-words",
          description: "!text-body-medium-regular",
          actionButton:
            "!bg-transparent !text-mono-000 !border-0 !rounded-md !p-1 hover:!bg-mono-000/10",
          cancelButton:
            "!bg-transparent !text-mono-000 !border-0 !rounded-md !p-1 hover:!bg-mono-000/10",
          closeButton:
            "!bg-transparent !text-mono-000 !border-0 !rounded-md !p-1 hover:!bg-mono-000/10",
          icon: "w-5! h-5! mx-0!",
        },
      }}
      position="bottom-center"
      style={
        {
          "--normal-bg": "var(--mono-800)",
          "--normal-text": "var(--mono-000)",
          "--normal-border": "var(--mono-800)",
          "--success-bg": "var(--green-900)",
          "--success-text": "var(--mono-000)",
          "--success-border": "var(--green-900)",
          "--warning-bg": "var(--warning-700)",
          "--warning-text": "var(--mono-000)",
          "--warning-border": "var(--warning-700)",
          "--error-bg": "var(--error-700)",
          "--error-text": "var(--mono-000)",
          "--error-border": "var(--error-700)",
          "--info-bg": "var(--blue-900)",
          "--info-text": "var(--mono-000)",
          "--info-border": "var(--blue-900)",
          "--toast-width": "min(90vw, 480px)",
          "--toast-margin": "0 auto",
        } as React.CSSProperties
      }
      icons={{
        success: (
          <CheckCircleFilledIcon
            width={20}
            height={20}
            className="text-green-100"
          />
        ),
        error: (
          <ErrorMarkFilledIcon
            width={20}
            height={20}
            className="text-error-100"
          />
        ),
        warning: (
          <WarningMarkFilledIcon
            width={20}
            height={20}
            className="text-warning-100"
          />
        ),
        info: (
          <QuoteFilledIcon
            width={20}
            height={20}
            className="text-blue-100"
          />
        ),
        loading: (
          <SpinnerIcon
            width={20}
            height={20}
            className="text-mono-500 animate-spin"
          />
        ),
      }}
      {...props}
    />
  );
};

export { Toaster };
